const config = [
  {
    name: 'system',
    port: 'http://localhost:4010/',
    moduleid: '0',    // name 和 moduleid 对应
  }
  , {
    name: 'gecko',
    port: 'http://localhost:4011/',
    moduleid: '1',    // name 和 moduleid 对应
  }
  , {
    name: 'monitor',
    port: 'http://localhost:4012/',
    moduleid: '2',    // name 和 moduleid 对应
  }
]
if (process.env.NODE_ENV === 'production') {
  // 基座应用和子应用部署在同一个域名下，这里使用location.origin进行补全
  config.forEach(item => {
    item.port = `${window.location.origin}/${item.name}/`
  })
}
// '172.21.8.208:4011'

// 子应用端口名称配置
export const microConfig = config

// MainLayout 框架内子应用
export const microRoute = () => {
  let arr = []
  microConfig.forEach(subApp => {
    arr.push({
      path: subApp.name + '/#/', // 这里要把父路由的路径也带上
      name: subApp.name,
      component: () => import('@/micro-app/component/subCommon'),
    }, {
      path: subApp.name + '/*', // 防止主应用刷新史404
    }, )
  });
  return arr
}



// WEBPACK FOOTER //
// ./src/micro-app/port-config.js